import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Text,
  useToast,
} from '@chakra-ui/react'
import { DragAndDrop } from '../../../components/DragAndDrop'
import { useForm } from 'react-hook-form'
import { user } from '../../../helpers/user'
import { useMutation } from 'react-query'
import { api } from '../../../services/api'
import { useEffect } from 'react'

async function onUpdateNota(data) {
  const response = await api.post('/site/v2/categoria/retira-pendencia-conferencia', data)

  return response.data
}

export function ValidarNota({ nunotaToUpdate, resultado }) {
  const {
    control,
    handleSubmit,
    resetField,
    formState: { isDirty, isValid },
  } = useForm()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: onUpdateNota,
    onSuccess: () => {
      onClose()
      resetField('files')

      toast({
        title: 'Sucesso!',
        description: 'Nota validada com sucesso!',
        status: 'success',
      })

      resultado({
        codParc: '',
        pedido: '',
        dataDe: '',
        dataAte: '',
        pendente: '',
        nfe: '',
      })
    },

    onError: (error) => {
      toast({
        title: 'Erro!',
        description: 'Erro ao validar nota! entre em contato com o suporte.',
        status: 'error',
      })
    },
  })

  async function onSubmit(data) {
    if (!data.files.name.endsWith('.pdf')) {
      toast({
        title: 'Erro!',
        description: 'Selecione um arquivo pdf.',
        status: 'error',
        duration: 9000,
        isClosable: true,
      })
      return
    }

    const formData = new FormData()
    formData.append('arquivo', data.files)
    formData.append('codigo_usuario', user.codigo_usuario)
    formData.append('numero_nota', nunotaToUpdate)

    await mutateAsync(formData)
  }

  useEffect(() => {
    resetField('files')
  }, [nunotaToUpdate])

  return (
    <>
      <Button onClick={onOpen} variant="outline">
        Validar Nota
      </Button>

      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>Você está validando a nota: {nunotaToUpdate}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text color="gray.500" fontSize="sm" mb={4}>
              Selecione o PDF da nota fiscal: {nunotaToUpdate}
            </Text>

            <DragAndDrop control={control} multiple={false} />
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button colorScheme="blue" type="submit" isLoading={isLoading} disabled={!isDirty || !isValid || isLoading}>
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
